'use client';
import { useEffect } from 'react';

import { useBookmarksList } from '@/services/query';
import { setBookmarkedEventIds, useAppDispatch } from '@/store';

/**
 * Global hook to sync backend-fetched bookmarks with Redux state.
 * This allows all components (MarketCard, etc.) to perform O(1) checks
 * for bookmarked status without additional network requests.
 */
export function useSyncBookmarks(isAuthenticated: boolean) {
  const dispatch = useAppDispatch();

  const { data } = useBookmarksList({
    enabled: isAuthenticated,
    limit: 100,
  });

  useEffect(() => {
    if (!isAuthenticated) {
      dispatch(setBookmarkedEventIds([]));
    }
  }, [isAuthenticated, dispatch]);

  useEffect(() => {
    if (data?.pages) {
      const eventIds = data.pages.flatMap((page) =>
        page.data
          .map((item) => {
            const event = Array.isArray(item.event) ? item.event[0] : item.event;
            return event?.id;
          })
          .filter(Boolean)
      );

      dispatch(setBookmarkedEventIds(eventIds));
    }
  }, [data, dispatch]);
}
